<template>
  <div class="template-pilot-profile">
    <div class="row">
      <div class="col-sm-12">
        <div class="card bg-primary">
          <div class="card-body profile-user-box">
            <div class="row">
              <div class="col-sm-8">
                <div v-if="propDataReady">
                  <info :pilotData="pilotData" />
                </div>
              </div>
              <!-- end col-->
              <div class="col-sm-4">
                <div class="text-center mt-sm-0 mt-3 text-sm-right">
                  <router-link to="/admin/pilot">
                    <button type="button" class="btn btn-light mr-1">
                      <i class="mdi mdi-arrow-left mr-1"></i> Back
                    </button>
                  </router-link>
                  <button
                    type="button"
                    class="btn btn-light ml-1"
                    @click="editPilotProfile()"
                  >
                    <i class="mdi mdi-account-edit mr-1"></i> Edit Profile
                  </button>
                </div>
              </div>
              <!-- end col-->
            </div>
            <!-- end row -->
          </div>
          <!-- end card-body/ profile-user-box-->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div v-if="propDataReady">
          <card :pilotData="pilotData" />
        </div>
      </div>
      <div class="col-lg-8">
        <div v-if="propDataReady">
          <flights :pilotData="pilotData" />
        </div>
      </div>
    </div>
    <div>
      <div class="col-lg-12">
        <pilotorderlist :pilotId="pilotId" />
      </div>
    </div>
  </div>
</template>

<script>
import info from "@/components/subcomponents/pilot/profile/info";
import card from "@/components/subcomponents/pilot/profile/card";
import flights from "@/components/subcomponents/pilot/profile/flights";
import pilotorderlist from "@/components/subcomponents/pilot/profile/pilotOrderList";
import { GET_PILOT_DATA } from "@/graphql/queries/queries";

const PILOT_ATTRIBUTE = "pilots_by_pk";

export default {
  name: "profile",
  components: {
    info,
    card,
    flights,
    pilotorderlist,
  },
  data() {
    return {
      pilotData: {},
      propDataReady: false,
      pilotId: this.$route.params.pilotID,
    };
  },
  methods: {
    editPilotProfile() {
      this.$router.push({
        name: "pilotAdd",
        params: { pilotID: this.pilotId },
      });
    },
  },
  apollo: {
    pilotData: {
      // graphql query
      query: GET_PILOT_DATA,
      variables() {
        // Use vue reactive properties here
        return {
          pilot_id: this.pilotId,
        };
      },
      update(data) {
        this.propDataReady = true;
        return data[PILOT_ATTRIBUTE];
      },
      error(error) {
        this.error = JSON.stringify(error.message);
        console.error(this.error);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.template-pilot-profile {
  padding-top: 24px;
}
</style>
